import { notify } from 'helpers/notification'
import errorCodeConfig from 'utils/errorCopies'

export const handleError = error => {
    const errorCode = error?.response?.data?.error_code
    const errorMessage = errorCodeConfig[errorCode || '000']
    notify.error(errorMessage)
}
